import { decryptData } from '../../utils/encryptionService';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const LoadLimitsFromStorage = createAsyncThunk(
    'currentUser/loadLimitsFromStorage',
    async () => {
        const encryptedLimits = localStorage.getItem('encryptedLimits');
        return encryptedLimits ? decryptData(encryptedLimits) : null;
    }
);